// extracted by mini-css-extract-plugin
export default {"quantity":"QuantityCounter_quantity__c95gK","quantity_button":"QuantityCounter_quantity_button__k2OXP","quantity_value":"QuantityCounter_quantity_value__EJS2b"};